import { Component, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ShowsService } from 'src/app/services/shows.service';

@Component({
  selector: 'app-show-report',
  templateUrl: './show-report.component.html',
  styleUrls: ['./show-report.component.scss'],
  standalone: false
})
export class ShowReportComponent {
  ladding: boolean = false;
  formatted: string = '';
  listeners: any;
  play_offset_ms: any;
  song_time_ms: any;
  dataSource: any;
  fingerprints_columns: string[] = ['title', 'album', 'artist', 'release_date', 'score','sample_begin_time_offset_ms','sample_end_time_offset_ms', 'duration_ms', 'song_time_ms'];
  error_massage: string = '';
  processing: boolean = false;
  addShows!: FormGroup;
  show_start_data: any;
  show_end_data: any;


  fingerprintsData = new MatTableDataSource<any>([]);
  total_reports: number = 0;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  start_date: any;
  end_date: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private fb: FormBuilder, public showsService: ShowsService) {
    this.start_date = data.start_date;
    this.end_date = data.end_date;
    this.addShows = this.fb.group({
      Listeners: ['', Validators.required],
    });
    console.log('this.start_date',this.start_date);
    console.log('this.end_date',this.end_date);

  }
  onStartDateChange(event: MatDatepickerInputEvent<Date>) {
    this.start_date = event.value;
    console.log('Selected start date:', this.start_date);
  }
  onEndDateChange(event: MatDatepickerInputEvent<Date>) {
    this.end_date = event.value;
    console.log('Selected End date:', this.end_date);
  }

  ngAfterViewInit() {
    this.fingerprintsData.paginator = this.paginator;
  }

  billingInfo() {
    const startDateISO = this.start_date ? this.start_date.toISOString() : null;
    const endDateISO = this.end_date ? this.end_date.toISOString() : null;

    this.error_massage = '';
    this.processing = true;
    const showCode = this.addShows.value.Listeners;

    this.showsService.getShowReporting(showCode,startDateISO,endDateISO).subscribe({
      next: (res: any) => {
       let fingerprintsData =  res.fingerprints || [];
       this.show_start_data = res.startDateFormatted || '';
       this.show_end_data = res.endDateFormatted || '';

        this.listeners = res.actions_count || 0;
        const fingerprints = res.fingerprints || [];
        this.play_offset_ms = fingerprints.map((element: any) => ({
          ...element,
          song_time: res.song_time,
          song_time_ms: (element.sample_end_time_offset_ms - element.sample_begin_time_offset_ms) * this.listeners
        }));
        this.fingerprintsData.data = this.play_offset_ms;

        const totalDuration = fingerprints.reduce((sum: number, item: any) => {
          return sum + (item.duration_ms || 0);
        }, 0);

        const totalSeconds = Math.floor(totalDuration / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        this.dataSource = res.transactions || [];
        this.fingerprintsData.data = this.play_offset_ms;
        this.total_reports = this.play_offset_ms.length;
        this.ladding = true;
        this.processing = false;
      },
      error: () => {
        this.error_massage = 'No Data found for the provided Show Code.';
        this.processing = false;
      }
    });
  }
  formatDuration(ms: number): string {
    if (!ms || ms < 0) return '0s';

    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`;
    } else if (minutes > 0) {
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    } else {
      return `${seconds}s`;
    }
  }
  convertLongSongTime(timeStr: string): string {
    if (!timeStr) return '';
    const parts = timeStr.split(':').map(Number);
    if (parts.length === 2) {
      let minutes = parts[0];
      const seconds = parts[1];
      if (minutes >= 60) {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        return `${hours}:${remainingMinutes.toString().padStart(2, '0')}:${seconds
          .toString()
          .padStart(2, '0')}`;
      }
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }

    return timeStr;
  }



}
